module.exports = __webpack_public_path__ + "1792395595471/images/Metronic_fda1334c35d0f5fe2afb3afebbb6774a.32abe94.svg";